'use client';

import React from 'react';
import Link from 'next/link';

const Footer = () => {
  return (
    <footer className="bg-[#3D669D] text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col space-y-6">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">West Virginia Wire</h3>
              <p className="text-sm text-gray-300">
                Your source for news and information about West Virginia
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link href="/about" className="hover:text-blue-400 transition duration-300">About Us</Link></li>
                <li><Link href="/pricing" className="hover:text-blue-400 transition duration-300">Pricing</Link></li>
                <li><Link href="/contact" className="hover:text-blue-400 transition duration-300">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Legal</h3>
              <ul className="space-y-2 text-sm">
                <li><Link href="/privacy" className="hover:text-blue-400 transition duration-300">Privacy Policy</Link></li>
                <li><Link href="/terms" className="hover:text-blue-400 transition duration-300">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-600 pt-6 text-center">
            <p className="text-sm text-gray-300">
              © 2025 West Virginia Wire. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
